import {useEffect} from 'react';
import {Outlet, useLocation, useNavigate} from 'react-router-dom';
import {OrganizerHeader} from '../screens/eventsScreens/OrganizerHeader';
import {useOrganizerStore} from '../../common/stores/useOrganizerStore';
import {
  useCategories,
  useCategoriesWithTags,
} from '../../common/hooks/useCategories';
import {useUiStore} from '../../common/stores/useUiStore';
import {useTagsStore} from '../../common/stores/useTagsStore';
import {
  useEventDetailsStore,
  useEventDtoStore,
  useEventListStore,
} from '../../common';
import {useAuthStore} from '../../common/stores/useAuthStore';

export const OrganizerLayout = () => {
  const {showBackButton, onBackButtonClick} = useUiStore(state => state);
  const isNavOpen = useUiStore(state => state.isNavOpen);
  const {organizer, clearOrganizer} = useOrganizerStore();
  const {clearSelectedTagCodes} = useTagsStore();
  const {clearEventDto} = useEventDtoStore();
  const {clearEventDetails} = useEventDetailsStore();
  const {clearEventListStore} = useEventListStore();
  const navigate = useNavigate();
  const location = useLocation();
  const {viewMode, onChangeViewMode, clearViewMode} = useAuthStore();

  useCategoriesWithTags();
  useCategories();
  useLocation();

  useEffect(() => {
    const path = location.pathname;

    const viewModeAgnosticPrefixes = ['/places/approve'];
    const isViewModeAgnostic = viewModeAgnosticPrefixes.some(p =>
      path.startsWith(p),
    );

    if (!isViewModeAgnostic && viewMode === 'places' && !path.includes('all')) {
      navigate('/places/all');
    } else if (
      !isViewModeAgnostic &&
      viewMode === 'events' &&
      path.includes('all')
    ) {
      navigate('/events/all');
    }
  }, [viewMode, location.pathname, navigate]);

  const handleClear = () => {
    clearOrganizer();
    clearSelectedTagCodes();
    clearEventDto();
    clearEventDetails();
    clearEventListStore();
    clearViewMode();
  };

  return (
    <div
      className={`app-shell organizer-shell ${isNavOpen ? 'nav-open' : ''}`}
      style={layoutWrapperStyle}>
      <OrganizerHeader
        name={organizer?.name || ''}
        companyName={organizer?.companyName || ''}
        onClear={handleClear}
        showBack={showBackButton}
        onBackButtonClick={onBackButtonClick}
        viewMode={viewMode}
        onChangeViewMode={onChangeViewMode}
      />

      <main style={{paddingTop: '80px'}}>
        <Outlet />
      </main>
    </div>
  );
};

const layoutWrapperStyle: React.CSSProperties = {
  backgroundColor: '#1a1a1a',
  minHeight: '100vh',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
};
